import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      role="navigation"
      aria-label="メインナビゲーション"
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}
          aria-label="家の管理おまかせパック トップへ戻る"
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://public.readdy.ai/ai/img_res/58da60f9-74f3-471a-bb7f-e3e73c5a08d9.png"
            alt="家の管理おまかせパック ロゴ"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <ul role="list" className="hidden md:flex items-center gap-6 text-sm font-medium">
          {[
            { label: 'サービス内容', id: 'merit' },
            { label: '料金プラン', id: 'price' },
            { label: '対応エリア', id: 'area' },
            { label: 'よくある質問', id: 'faq' },
            { label: 'キャンペーン', id: 'campaign' },
          ].map((item) => (
            <li key={item.id}>
              <a
                href={`#${item.id}`}
                onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}
                aria-label={`${item.label}セクションへ移動`}
                className={`cursor-pointer transition-colors whitespace-nowrap ${
                  scrolled ? 'text-stone-700 hover:text-amber-700' : 'text-white hover:text-amber-200'
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
          <li>
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}
              aria-label="無料相談・お問い合わせフォームへ移動"
              className="cursor-pointer whitespace-nowrap bg-amber-600 hover:bg-amber-700 text-white px-5 py-2 rounded-full text-sm font-semibold transition-colors"
            >
              無料相談はこちら
            </a>
          </li>
        </ul>

        {/* Mobile Hamburger */}
        <button
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? 'text-stone-700' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'メニューを閉じる' : 'メニューを開く'}
          aria-expanded={menuOpen}
          aria-controls="mobile-menu"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          id="mobile-menu"
          role="menu"
          aria-label="モバイルナビゲーション"
          className="md:hidden bg-white border-t border-stone-100 px-4 py-4 flex flex-col gap-3"
        >
          {[
            { label: 'サービス内容', id: 'merit' },
            { label: '料金プラン', id: 'price' },
            { label: '対応エリア', id: 'area' },
            { label: 'よくある質問', id: 'faq' },
            { label: 'キャンペーン', id: 'campaign' },
          ].map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              role="menuitem"
              onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}
              aria-label={`${item.label}セクションへ移動`}
              className="cursor-pointer text-stone-700 text-sm font-medium text-left py-2 border-b border-stone-100 whitespace-nowrap"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            role="menuitem"
            onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}
            aria-label="無料相談・お問い合わせフォームへ移動"
            className="cursor-pointer bg-amber-600 text-white px-5 py-3 rounded-full text-sm font-semibold whitespace-nowrap text-center"
          >
            無料相談はこちら
          </a>
        </div>
      )}
    </nav>
  );
}
